import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";
import Loading from "../../UiComponents/Loading";
import CubeElementsList, {CubeColumn} from "./CubeElementsList";
import {JourneyPhase} from "../../../Domain/Models/Cube";
import {groupRepository} from "../../../Domain/Repositories/GroupRepository";
import {CompletedCubeService} from "../../../Domain/Services/CompletedCubeService";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import Group from "../../../Domain/Models/Group";
import WaitingArea from "./WaitingArea";
import StatsHeader from "./StatsHeader";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  headerTable: {
    tableLayout: 'fixed',
    marginBottom: '20px'
  },
  headerName: {
    color: '#FFFFFF'
  },
  table: {
    tableLayout: 'fixed'
  },
  oddColumn: {
    backgroundColor: '#222222',
    verticalAlign: 'top',
    alignContent: 'center'
  },
  evenColumn: {
    backgroundColor: '#2D2D2D',
    verticalAlign: 'top',
    alignContent: 'center'
  },
  oddHeader: {
    backgroundColor: '#222222',
    color: '#FFFFFF',
    textAlign: 'center'
  },
  evenHeader: {
    backgroundColor: '#2D2D2D',
    color: '#FFFFFF',
    textAlign: 'center'
  }
}));

let requestInProgressRef = false;
export default function LiveViewContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);

  const [loading, setLoading] = useState(false);
  const [numberOfCubesToComplete, setNumberOfCubesToComplete] = useState<number>(7);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [trafficStatus, setTrafficStatus] = useState<TrafficShapingStatus>({
    isRunning: false,
    isTreeCalculated: false,
    runningWithoutRules: false,
    lastErrorMessage: "",
    groupsPerHour: 0,
    peoplePerHour: 0,
    cubeMatchingEntries: [],
    numberOfEntriesInQueue: 0,
    kickedGroups: []
  });

  requestInProgressRef = requestInProgress;
  const stateLoop = () =>
  {
    if (requestInProgressRef)
    {
      return;
    }

    setRequestInProgress(true);
    TrafficShapingService.getStatus()
      .then(x =>
      {
        setTrafficStatus(x);
        setRequestInProgress(false);
      })
      .then(() => groupRepository.load())
      .catch((e: Error) =>
      {
        console.error(e);
        setRequestInProgress(false);
      });
  }
  
  useEffect(() =>
  {
    setLoading(true);
    cubeRepository.load()
      .then(() => groupRepository.load())
      .then(() => TrafficShapingService.getSettings())
      .then((settings) => setNumberOfCubesToComplete(settings.numberOfCubesToComplete))
      .then(() => setLoading(false))
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      })
    
    stateLoop();

    let interval = setInterval(stateLoop, 15000);
    return () => clearInterval(interval);
  }, [])

  return (
    <>
      <ErrorCardController ref={errorCardControllerRef}/>
      <Loading isLoading={loading}>
        <Paper className={classes.paper}>

          <StatsHeader trafficShapingStatus={trafficStatus} />

          <TableContainer>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.oddHeader}>Waiting Area</TableCell>
                  <TableCell className={classes.evenHeader}>Start/Middle</TableCell>
                  <TableCell className={classes.oddHeader}>Middle</TableCell>
                  <TableCell className={classes.evenHeader}>End</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={0}>
                  <TableCell className={classes.oddColumn} scope="row">
                    <WaitingArea trafficShapingStatus={trafficStatus} />
                  </TableCell>
                  <TableCell className={classes.evenColumn}>
                    <CubeElementsList
                      cubes={cubeRepository.cubes?.filter(x => x.journeyPhases.includes(JourneyPhase.Start))}
                      cubeColumn={CubeColumn.Left}
                    />
                  </TableCell>
                  <TableCell className={classes.oddColumn}>
                    <CubeElementsList
                      cubes={cubeRepository.cubes?.filter(x => 
                        x.journeyPhases.includes(JourneyPhase.Middle) &&
                        !x.journeyPhases.includes(JourneyPhase.Start))}
                      cubeColumn={CubeColumn.Center}
                    />
                  </TableCell>
                  <TableCell className={classes.evenColumn}>
                    <CubeElementsList
                      cubes={cubeRepository.cubes?.filter(x => x.journeyPhases.includes(JourneyPhase.End))}
                      cubeColumn={CubeColumn.Right}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </Loading>
    </>
  );
}